import { useCallback } from 'react';

import { publicEnvConfig } from 'config/public';
import { useFeatureToggle, useIsCompanySite } from 'hooks';
import { useB2bB2cSwitchGTM } from 'hooks/gtm';
import { removeCookie } from 'utils/cookies';
import { getRootDomain, getUrlWithSubdomain } from 'utils/url';

export function useSiteSwitcher() {
	const { julaProEnabled } = useFeatureToggle();
	const isCompanySite = useIsCompanySite();
	const { sendB2bB2cSwitchEvent } = useB2bB2cSwitchGTM();
	const privateSiteSubdomain = publicEnvConfig.PRIVATE_SITE_SUBDOMAIN;
	const companySiteSubdomain = publicEnvConfig.COMPANY_SITE_SUBDOMAIN;
	const prefersCompanySiteCookieName =
		publicEnvConfig.PREFERS_COMPANY_SITE_COOKIE_NAME;

	const hasRequiredEnvs =
		privateSiteSubdomain &&
		companySiteSubdomain &&
		prefersCompanySiteCookieName;

	const siteSwitchingEnabled = julaProEnabled && hasRequiredEnvs;
	const switchSite = useCallback(() => {
		const targetUrl = getUrlWithSubdomain(
			globalThis.location.href,
			isCompanySite ? privateSiteSubdomain : companySiteSubdomain,
		);
		if (!targetUrl) {
			return;
		}
		if (isCompanySite && prefersCompanySiteCookieName) {
			removeCookie({
				name: prefersCompanySiteCookieName,
				domain: getRootDomain(globalThis.location.origin),
			});
		}
		sendB2bB2cSwitchEvent();
		globalThis.location.assign(targetUrl);
	}, [
		companySiteSubdomain,
		isCompanySite,
		prefersCompanySiteCookieName,
		privateSiteSubdomain,
		sendB2bB2cSwitchEvent,
	]);
	return {
		switchSite: siteSwitchingEnabled ? switchSite : undefined,
	};
}
